// export.ts — CSV export of a member's chores + logged completions (all local; nothing
// leaves the device). Built client-side.

import type { Member, Chore, CompletionView } from "./store";

function cell(v: string | number | null | undefined): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number | null | undefined)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** One combined CSV with a Kind column so chores and completions can share a file. */
export function buildExport(
  member: Member,
  chores: Chore[],
  completions: CompletionView[],
): { csv: string; filename: string } {
  const rows: (string | number | null | undefined)[][] = [];
  for (const ch of chores) {
    rows.push(["chore", "", ch.name, ch.cadence, ch.points, ch.active ? "active" : "retired", ""]);
  }
  for (const c of completions) {
    rows.push(["done", c.done_on, c.chore_name, c.cadence, c.points, "", c.note]);
  }
  const out = csv(
    ["Kind", "Done on", "Chore", "Cadence", "Points", "Status", "Note"],
    rows,
  );
  const stamp = new Date().toISOString().slice(0, 10);
  const safeName = member.name.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "member";
  return { csv: out, filename: `oriora-chores-${safeName}-${stamp}.csv` };
}
